module.exports = __webpack_public_path__ + "static/media/slunickodetem.02a3c232.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/slunickodetem.png
// module id = 502
// module chunks = 0